import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { inject } from '@angular/core';
import { DeepCopyService } from '../../../services/support/deep-copy/deep-copy.service';

export abstract class FormTracking<T extends Record<keyof T, AbstractControl>> {
  protected deepCopyService: DeepCopyService = inject(DeepCopyService);

  protected initialFormValue!:
    | ReturnType<FormGroup<T>['getRawValue']>
    | ReturnType<FormArray<FormGroup<T>>['getRawValue']>;

  public hasUnsavedChanges(
    form: FormGroup<T> | FormArray<FormGroup<T>>
  ): boolean {
    return (
      JSON.stringify(this.initialFormValue) !==
      JSON.stringify(form.getRawValue())
    );
  }

  protected initFormTracking(
    form: FormGroup<T> | FormArray<FormGroup<T>>
  ): void {
    this.initialFormValue = this.deepCopyService.createDeepCopy(
      form.getRawValue()
    );
  }
}
